import { Dropdown, Row } from 'react-bootstrap'
import SearchBar from 'pages/HomePage/components/SearchBar'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import noDataIcon from 'assets/images/profilepage-gifthist-nodata.svg'
import { useQuery } from 'react-query'
import { getGiftHistQuery } from 'dataLayer/user'

// export const RANKING = {
// 	1: 'Today',
// 	2: 'This week',
// 	3: 'This month',
// }

function GiftHist() {
	const { t } = useTranslation()
	const RANKING = {
		1: `${t('profile.gift_hist.today')}`,
		2: `${t('profile.gift_hist.this_week')}`,
		3: `${t('profile.gift_hist.this_month')}`,
	}
	const [dateFilter, setDateFilter] = useState(3)
	const { data: giftHist } = useQuery(getGiftHistQuery(dateFilter, 0, 10))

	// TODO: Search and filter date dropdown

	return (
		<>
			<Row className="profilepage-content__title">
				{t('profile.gift_hist.title')}
			</Row>
			<Row>
				<div className="search-bar gift-hist mt-3">
					<SearchBar type="text" placeholder={t('profile.gift_hist.search')} />
					<Dropdown align="end">
						<Dropdown.Toggle>{RANKING[dateFilter]}</Dropdown.Toggle>
						<Dropdown.Menu>
							<Dropdown.Item
								onClick={() => setDateFilter(Object.keys(RANKING)[2])}
							>
								{t('profile.gift_hist.this_month')}
							</Dropdown.Item>
							<Dropdown.Item
								onClick={() => setDateFilter(Object.keys(RANKING)[1])}
							>
								{t('profile.gift_hist.this_week')}
							</Dropdown.Item>
							<Dropdown.Item
								onClick={() => setDateFilter(Object.keys(RANKING)[0])}
							>
								{t('profile.gift_hist.today')}
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</div>
			</Row>
			<Row
				className={`profilepage-content__body 
				${giftHist?.length > 0 ? 'gifthist' : 'no-gifthist'} my-3`}
			>
				{giftHist?.length > 0 ? (
					giftHist?.map(item => {
						return (
							<div
								key={item?.id}
								className="reward"
								style={{
									backgroundImage: `url(${item?.image})`,
								}}
							>
								<div className="reward-title">
									<p>{item?.name}</p>
									<p>{item?.description}</p>
								</div>
								<div className="reward-date">
									{new Intl.DateTimeFormat('lo-LA').format(
										new Date(item?.received_time),
									)}
								</div>
							</div>
						)
					})
				) : (
					<img src={noDataIcon} alt="No reward is found" />
				)}
			</Row>
		</>
	)
}

export default GiftHist
